import { Component } from '@angular/core';
import { ORCIDDistinctionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Distinctions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orciddistinction-form',
    templateUrl: './orciddistinction.form.component.html'
})
export class ORCIDDistinctionFormComponent extends BaseFormComponent {
    public record!: ORCIDDistinctionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

